import "./gameDisplay.scss";
import { Stack, Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { GameWithID } from "../../../models/Game";
import GameDisplay from "./GameDisplay";
import { useLeaguePaths } from "../../../data/LeagueEnvironmentProvider";
import { GameDisplayHeight } from "./Constants";

interface Props {
  game: GameWithID;
}

export default function PastGame({ game }: Props) {
  const { getReportsBasePath, getPorTeamAbbrev } = useLeaguePaths();
  // Determine the link destination and button state
  // Backward compatibility with legacy game report URLs
  const getLinkProps = () => {
    if (game.teamReportId && game.nbaGameId) {
      // Team report available – use new team report URL
      const reportId = `${getPorTeamAbbrev()}-game-${game.nbaGameId}`;
      return {
        to: `${getReportsBasePath()}/${getPorTeamAbbrev()}?report=${reportId}`,
        disabled: false,
        text: "Game Report",
        // Built from CTG's same-night feed; the processed rebuild clears it
        subText: game.reportFeed === "delayed" ? "(preliminary)" : undefined,
      };
    } else if (game.reportAvailable) {
      // Legacy game report available
      return {
        to: `/games/${game.id}`,
        disabled: false,
        text: "Game Report",
      };
    } else {
      // No report yet: the game is still on, or over and its report not built
      return {
        to: "#",
        disabled: true,
        text: game.status === "live" ? "In progress" : "Report pending",
      };
    }
  };

  const linkProps = getLinkProps();

  return (
    <Stack
      direction="row"
      className="game-display--container past"
      sx={{
        height: GameDisplayHeight,
      }}
    >
      <GameDisplay game={game} />
      <Box className="game-display--button-container">
        <Button
          component={Link}
          to={linkProps.to}
          className="game-display--report-link"
          disabled={linkProps.disabled}
        >
          {linkProps.subText ? (
            <Stack alignItems="center" spacing={0.25}>
              <span>{linkProps.text}</span>
              <span className="game-display--report-subtext">
                {linkProps.subText}
              </span>
            </Stack>
          ) : (
            linkProps.text
          )}
        </Button>
      </Box>
    </Stack>
  );
}
